import React, { useEffect } from 'react';
import './Intro.scss';
import HowTo from './HowTo';
import closeIcon from '../../assets/collapse.svg';

function HowToPopUp({ handleClickClose, howtoRef, showHowToInfo }) {
  useEffect(() => {
    howtoRef.current.style.animation = 'fadeIn .7s ease-in forwards';
  }, [howtoRef]);

  return (
    <div className={showHowToInfo ? 'intro__content howtoInfo' : 'intro__content'}>
      <div
        className={showHowToInfo ? 'intro__popup howtoInfo__popup' : 'intro__popup'}
        ref={howtoRef}
      >
        <img
          src={closeIcon}
          className="intro__popup__close"
          alt="close"
          onClick={handleClickClose}
        />
        <HowTo />
        <button className="intro__popup__button" onClick={handleClickClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default HowToPopUp;
